import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion
import Box from "./logo";
import box1 from "../assets/images/icons/Box-1.svg";
import box2 from "../assets/images/icons/Box-2.svg";
import box3 from "../assets/images/icons/Box-3.svg";
import box4 from "../assets/images/icons/Box-4.svg";
import box5 from "../assets/images/icons/Box-5.svg";
import box6 from "../assets/images/icons/Box-6.svg";
import box7 from "../assets/images/icons/Box-7.svg";
import box8 from "../assets/images/icons/Box-8.svg";

const boxVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", delay: i * 0.2 },
  }),
};

function SectionFour() {
  return (
    <div className="sec-4">
      {/* Heading with Animation */}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        The <br />
        Recommended <br /> Wallets
      </motion.h1>

      {/* Boxes Section */}
      <div className="boxes">
        {/* Column 1 */}
        <div className="box-1">
          {[box1, box2, box3, box4].map((box, i) => (
            <motion.div
              key={i}
              className="box"
              variants={boxVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              custom={i}
            >
              <Box box={box} />
            </motion.div>
          ))}
        </div>

        {/* Column 2 */}
        <div className="box-2">
          {[box5, box6, box7, box8].map((box, i) => (
            <motion.div
              key={i}
              className="box"
              variants={boxVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              custom={i}
            >
              <Box box={box} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionFour;
